/**
 * 教育程度枚举
 */
export default Object.freeze(['博士研究生', '硕士研究生', '本科', '专科', '高职'])